var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d20bb43a31a333a0b6d7c5dfa32880e9.svg#b';
                    var viewUrl = 'sprites.d20bb43a31a333a0b6d7c5dfa32880e9.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 58 58',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };